// A junk drawer: these haven't found a home yet. Move them into real groupings as those emerge.

/** Like Ramda's partition, but uses an `is` predicate to guarantee the return type of the first partition. */
export const partitionIs = <U extends T, T>(
  fn: (l: T) => l is U,
  list: readonly T[]
): [U[], T[]] => {
  const us: U[] = []
  const ts: T[] = []
  list.forEach(l => {
    if (fn(l)) {
      us.push(l)
    } else {
      ts.push(l)
    }
  })
  return [us, ts]
}

// Get all the possible combinations (unordered) of the given array's members.
// NB: will include `[]` and the full, given array.
// from: https://stackoverflow.com/a/42531964/2544629
export const combinations = <T>(array: T[]): T[][] => {
  /* eslint-disable no-bitwise */
  return new Array(1 << array.length)
    .fill(undefined)
    .map((_1, i) => array.filter((_2, j) => i & (1 << j)))
  /* eslint-enable no-bitwise */
}

/** Returns either `thing` iff `!condition`, or `mutate(thing)` iff `condition`. */
function mutateIf<T, U>(thing: T, condition: true, mutate: (t: T) => U): U
function mutateIf<T, U>(thing: T, condition: false, mutate: (t: T) => U): T
function mutateIf<T, U>(thing: T, condition: boolean, mutate: (t: T) => U): T | U
function mutateIf<T, U>(thing: T, condition: boolean, mutate: (t: T) => U): T | U {
  if (condition) {
    return mutate(thing)
  } else {
    return thing
  }
}
export {mutateIf}
